import React from 'react';
import ReactDOM from 'react-dom';
import { CopilotButton } from './copilot-button';

export const renderSearchInputIcon = (container, i18n, isNewLogo = false) => {
  ReactDOM.render(<CopilotButton i18n={i18n} isNewLogo={isNewLogo} />, container);
};

